import {
  Stack,
  Typography,
  Grid,
  MenuItem,
  Paper,
  Pagination,
  OutlinedInput,
  InputAdornment,
  Select,
  SelectChangeEvent,
  CircularProgress,
  Link,
} from "@mui/material";
import DashboardLayout from "../../../../Layouts/Dashboard/dashboard";
import BoxPaper from "../../../../Components/Misc/BoxPaper";
import { routePaths } from "../../../../Router/router";
import ContractDetailsCard from "../../../../Components/Cards/ContractDetailsCard/contract-details-card";
import SinglePageHeader from "../../../../Components/Misc/SinglePageHeader";
import React, { useState } from "react";
import { cacheService, rightService } from "../../../../Core/Api/services";
import GlobalConst from "../../../../Core/Utils/Constants/globals";
import moment from "moment";
import MetadataListTextItem from "../../../../Components/Misc/Metadata/MetadataListTextItem/metadata-list-text-item";
import { RightType } from "../../../../Core/Api/Types/right-type";
import usePagination from "../../../../Utils/Hooks/usePagination";
import ListPageHeader, {
  ListPageHeaderGroupActions,
  ListPageHeaderRight,
} from "../../../../Components/Misc/ListPageHeader";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { ContractAndRightType } from "../../../../Core/Api/Right/right-api-service";
import useBasketActions from "../../../../Utils/Hooks/useBasketActions";
import { Link as RouterLink, useParams } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";

function CustomerContractSingle() {
  const { t } = useTranslation();
  const params = useParams();

  const { addContractsToBasket } = useBasketActions();

  const [rightsContracts, setRightsContracts] = React.useState<ContractAndRightType[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const metadataFields = React.useMemo(() => cacheService.GetMetadata(), []);

  // Fetching data
  React.useEffect(() => {
    if (params.id) {
      rightService.GetRightContractById(parseInt(params.id), metadataFields).then((response) => {
        setRightsContracts(response);

        setIsLoading(false);
      });
    }
  }, [params.id]);

  const [rightSearchPattern, setRightSearchPattern] = React.useState<string>("");
  const [delivered, setDelivered] = React.useState<string[]>([]);
  const [filterDelivered, setFilterDelivered] = React.useState<string>("Default");
  const [rightType, setRightType] = React.useState<string[]>([]);
  const [filterRightType, setFilterRightType] = React.useState<string>("Default");
  const [titleType, setTitleType] = React.useState<string[]>([]);
  const [filterTitleType, setFilterTitleType] = React.useState<string>("Default");

  React.useEffect(() => {
    setDelivered(Object.values(["True", "False"]));
    setTitleType(Object.values(["Movie", "Season"]));
    setRightType(Object.values(RightType));
  }, []);

  const handleFilterDelivered = (event: SelectChangeEvent<string>) => {
    setFilterDelivered(event.target.value as string);
  };
  const handleFilterRightType = (event: SelectChangeEvent<string>) => {
    setFilterRightType(event.target.value as string);
  };
  const handleFilterTitleType = (event: SelectChangeEvent<string>) => {
    setFilterTitleType(event.target.value as string);
  };

  const onRigthPatternChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback((e) => {
    setRightSearchPattern(e.currentTarget.value);
  }, []);

  const handleAddToBasket = (id: string, territoriesString: string) => {
    const item = filtredRigths.find((x) => x.externalId === id && x.rightTerritoriesString === territoriesString);
    item && addContractsToBasket([item]);
  };

  // Pagination
  let [rightPage, setRightPage] = useState(1);
  let filtredRigths = rightsContracts.filter(
    (x) =>
      (filterRightType === "Default" || filterRightType === "All" || x.type === filterRightType) &&
      (filterTitleType === "Default" || x.titleType === filterTitleType) &&
      (filterDelivered === "Default" ||
        (x.okDelivery === true && filterDelivered === "True") ||
        (x.okDelivery === false && filterDelivered === "False")) &&
      (rightSearchPattern === "" ||
        x.mediaNamesString?.toLowerCase().includes(rightSearchPattern.toLowerCase()) ||
        x.customerName?.toLowerCase().includes(rightSearchPattern.toLowerCase()) ||
        x.externalId?.toLowerCase().includes(rightSearchPattern.toLowerCase()) ||
        x.workRecordId?.toLowerCase().includes(rightSearchPattern.toLowerCase()) ||
        x.titleInfos?.name.toLowerCase().includes(rightSearchPattern.toLowerCase()))
  );
  const PER_PAGE = 2;
  const rightsCount = Math.ceil(filtredRigths.length / PER_PAGE);
  const paginatedRights = usePagination(filtredRigths, PER_PAGE);

  const handleRightPageChange = (e, p) => {
    setRightPage(p);
    paginatedRights.jump(p);
  };

  return (
    <DashboardLayout withContainer sxContent={{ px: 2 }}>
      <Link
        color="white"
        underline="hover"
        component={RouterLink}
        to={routePaths.contractsAndRights.path}
        sx={{ mt: 1 }}
      >
        <ArrowBackIcon sx={{ mr: 0.5 }} />
        {t("button:backToRights")}
      </Link>
      <SinglePageHeader
        title={
          rightsContracts && rightsContracts.length > 0 && rightsContracts[0].titleInfos
            ? rightsContracts[0].titleInfos.name
            : GlobalConst.LOADING_TEXT
        }
        subtitle={t("common:title")}
        // backButton={{
        //   label: "Back to rights",
        //   to: routePaths.contractsAndRights.path,
        // }}
        mb={3}
      ></SinglePageHeader>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Paper elevation={0} sx={{ backgroundImage: "none", padding: "20px 24px", borderRadius: "12px", mb: 3 }}>
            <Typography variant="h5" component="h2">
              {t("common:contractsAndRights")}
            </Typography>
            <ListPageHeader mb={3} mt={2} elevated>
              <ListPageHeaderGroupActions elevated>
                <Select
                  displayEmpty
                  IconComponent={ExpandMoreRoundedIcon}
                  startAdornment={<SearchIcon />}
                  inputProps={{ "aria-label": "Without label" }}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                  value={filterDelivered}
                  onChange={(value) => handleFilterDelivered(value)}
                >
                  <MenuItem value={"Default"}>{t("menu:item.isDelivered")}</MenuItem>
                  {delivered.map((type, index) => (
                    <MenuItem value={type} key={index}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>

                <Select
                  displayEmpty
                  IconComponent={ExpandMoreRoundedIcon}
                  startAdornment={<SearchIcon />}
                  inputProps={{ "aria-label": "Without label" }}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                  value={filterRightType}
                  onChange={(value) => handleFilterRightType(value)}
                >
                  <MenuItem value={"Default"}>{t("menu:item.rightType")}</MenuItem>
                  {rightType.map((type, index) => (
                    <MenuItem value={type} key={index}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>

                <Select
                  displayEmpty
                  IconComponent={ExpandMoreRoundedIcon}
                  startAdornment={<SearchIcon />}
                  inputProps={{ "aria-label": "Without label" }}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                  value={filterTitleType}
                  onChange={(value) => handleFilterTitleType(value)}
                >
                  <MenuItem value={"Default"}>{t("field:label.titleTypeLowerCase")}</MenuItem>
                  {titleType.map((type, index) => (
                    <MenuItem value={type} key={index}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </ListPageHeaderGroupActions>
              <ListPageHeaderRight>
                <OutlinedInput
                  label={t("common:search")}
                  placeholder={t("common:search")}
                  onChange={onRigthPatternChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  }
                />
              </ListPageHeaderRight>
            </ListPageHeader>
            {isLoading && (
              <CircularProgress
                sx={{
                  position: "relative",
                  top: "50%",
                  left: "45%",
                }}
              />
            )}
            {!isLoading &&
              paginatedRights.currentData().map((el, index) => (
                <Stack spacing={1} mt={2} key={index}>
                  <ContractDetailsCard
                    handleAddToBasket={handleAddToBasket}
                    contractId={el.titleId}
                    contractTitle={el.titleInfos.name}
                    customerName={el.customerName}
                    broadcaster={el.broadcasterName}
                    startDate={moment(el.startDate).format(GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS)}
                    endDate={moment(el.endDate).format(GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS)}
                    id={el.externalId}
                    workId={el.workRecordId}
                    externalId={el.externalId}
                    rightType={el.type}
                    languages={el.rightLanguagesString.trim().split(" ")}
                    territories={el.rightTerritoriesString.trim().split(" ")}
                    mediaName={el.mediaNamesString}
                    titleType={el.titleType}
                    okDelivery={el.okDelivery}
                    territoriesString={el.rightTerritoriesString}
                    small
                  />
                </Stack>
              ))}
            <Pagination
              sx={{ mt: 2 }}
              count={rightsCount}
              hideNextButton
              hidePrevButton
              onChange={handleRightPageChange}
            />
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <BoxPaper mb={3} title={t("common:summary")}>
            <Stack mb={3}>
              <Typography variant="h6" color="text.tier" mb={2}>
                {t("panel:accordionTitle.globalInfos")}
              </Typography>
              <Stack spacing={1.5}>
                <MetadataListTextItem title={t("menu:item.contractId")}>{params.id}</MetadataListTextItem>
                <MetadataListTextItem title={t("menu:item.titleId")}>
                  {rightsContracts && rightsContracts.length > 0 && rightsContracts[0].titleId
                    ? rightsContracts[0].titleId
                    : "-"}
                </MetadataListTextItem>
                <MetadataListTextItem title={t("menu:item.numberOfDeals")}>
                  {rightsContracts.length}
                </MetadataListTextItem>
              </Stack>
            </Stack>
          </BoxPaper>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export default CustomerContractSingle;
